
export enum PontoPartidaEnum {
  usuario = 'usuario',
  estabelecimento = 'estabelecimento',
  semPonto = 'semPonto',
}
